import logo from './logo.svg'
import './App.css'
import HomeScreen from './pages/HomeScreen'

function App() {
  return (
    <>
  <HomeScreen/>
    </>
  )
}

export default App
